import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Radio, Clock } from 'lucide-react';
import AudioStream from './components/AudioStream';
import LastAudios from './components/LastAudios';
import './App.css';

function Navigation() {
  const location = useLocation();
  
  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex space-x-8">
            <Link
              to="/"
              className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Radio className="w-4 h-4 mr-2" />
              Live Stream
            </Link>
            <Link
              to="/letzte-jugendstunden"
              className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${
                location.pathname === '/letzte-jugendstunden'
                  ? 'border-blue-500 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Clock className="w-4 h-4 mr-2" />
              Letze Jugendstunden
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<AudioStream />} />
          <Route path="/letzte-jugendstunden" element={<LastAudios />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;